import {
  BCORP_PROFILE_URL,
  BCORP_BLACK_SVG,
  BCORP_WHITE_PNG,
  BCORP_BLACK_DIMS,
  BCORP_WHITE_DIMS,
} from "@/utils/bcorp";

/**
 * The official Certified B Corporation mark, linked to CanDo's B Corp
 * directory profile. Single rendering path for every mark on the site so
 * B Lab's non-negotiables (brand.bcorp.com/visual-identity, "Logo
 * application", updated 2026) hold everywhere:
 *
 *   - the mark MUST direct to bcorp.com — hyperlinking it to the company's
 *     directory profile satisfies this; internal links go on surrounding
 *     text, never on the mark
 *   - never below 72px tall on web pages — the `h-[72px]` default is the
 *     floor; pass `heightClassName` only to size UP
 *   - official artwork only, unmodified: black on light, white on dark —
 *     no other colors, effects, or alterations
 *   - alt is always "Certified B Corporation"
 *
 * Clear space (>= half the mark's width, all sides) is the caller's job — it
 * depends on the surrounding layout, so each call site sizes its own gaps.
 */
export default function BCorpMark({ variant = "black", heightClassName = "h-[72px]", className = "", testId }) {
  const isBlack = variant === "black";
  const dims = isBlack ? BCORP_BLACK_DIMS : BCORP_WHITE_DIMS;
  return (
    <a
      href={BCORP_PROFILE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block shrink-0"
      data-testid={testId}
    >
      <img
        src={isBlack ? BCORP_BLACK_SVG : BCORP_WHITE_PNG}
        alt="Certified B Corporation"
        width={dims.width}
        height={dims.height}
        className={`${heightClassName} w-auto ${className}`}
      />
    </a>
  );
}
